$(function () {
  initAccordions();
});

window.initAccordions = () => {
  $('.accordion').not('.js-ready').each(function () {
    var $this = $(this);
    var $heading = $this.find('> [data-toggle=accordion]');
    var $content = $this.find('> .accordion__content');

    $this.off('click').on('click', '[data-toggle=accordion]', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if ($this.hasClass('open')) {
        close();
      }
      else {
        open();
      }
    });

    if (isNested($heading.attr('id'))) {
      $this.addClass('isNested');
    }

    $this.addClass('js-ready');

    function open() {
      $this.find('[data-toggle=accordion]').attr('aria-expanded', true);
      $content.toggle('fast', () => {
        $this.addClass('open');
        const event = new Event('collapseClicked');
        window.dispatchEvent(event);
      });
    }
    function close() {
      $this.find('[data-toggle=accordion]').attr('aria-expanded', false);
      $content.toggle('fast', () => {
        $this.removeClass('open');
      });
    }
    function isNested(id) {
      var element = $("[id=" + id + "]").parent().parents('.accordion');
      if (element.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  });
};